import { JSXElementConstructor } from 'react';

import { createColumnHelper } from '@tanstack/react-table';

import { RowData } from '../../../src/utils';
import { RowActionMenu } from '../components/row-action/RowActionMenu/RowActionMenu';
import { ACTIONS_MENU_COLUMN_ID } from '../config/constants';
import { ActionColumnProps } from '../types/ActionColumn';

/**
 * Creates a row selection column that is by default not printable
 *
 * This can be over ridden when instantiating the column and using the meta property on the args
 */
function createActionsColumn<TData extends RowData>() {
  const columnHelper = createColumnHelper<TData>();
  type Accessor = typeof columnHelper.accessor;
  type TableMeta = Parameters<Accessor>[1]['meta'];
  type ColumnArgs = {
    meta?: TableMeta;
    Actions: JSXElementConstructor<ActionColumnProps<TData>>;
  };

  const selectionColumn = ({ meta, Actions }: ColumnArgs) =>
    columnHelper.display({
      size: 45,
      id: ACTIONS_MENU_COLUMN_ID,
      cell: (cellContext) => <RowActionMenu Actions={Actions} cellContext={cellContext} />,
      meta: {
        isPrintable: false,
        ...meta,
      },
    });

  return selectionColumn;
}

export { createActionsColumn };
